import { motion } from 'framer-motion';

const TrustedBy = () => {
  const clientLogos = [
    { name: 'NCHE', image: '/NCHE.png', alt: 'National Council for Higher Education' },
    { name: 'OPM', image: '/OPM.png', alt: 'Office of the Prime Minister' },
    { name: 'Project Hope', image: '/Project Hope.jpg', alt: 'Project Hope Namibia' },
    { name: 'Shipanga', image: '/Shipanga.png', alt: 'Shipanga' },
    { name: 'IntraHealth', image: '/IntraHealth.png', alt: 'IntraHealth Namibia' }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-slate-50 to-white border-t border-gray-200 relative overflow-hidden isolate">
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-purple-600 to-blue-600 opacity-15 rounded-full -translate-x-1/2 z-[-1] pointer-events-none"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-center text-3xl font-bold text-gray-900 mb-4">
            Trusted by Leading Organizations
          </h3>
          <p className="text-center text-blue-600 mb-12 max-w-2xl mx-auto">
            Proud to serve some of Namibia's most respected institutions
          </p>
        </motion.div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center">
          {clientLogos.map((logo, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ 
                delay: index * 0.1,
                duration: 0.5,
                type: "spring",
                stiffness: 100
              }}
              whileHover={{ 
                scale: 1.1, 
                y: -10,
                transition: { duration: 0.2 }
              }}
              className="flex items-center justify-center h-24 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer p-6 border border-gray-100"
            >
              <motion.img 
                src={logo.image} 
                alt={logo.alt} 
                className="max-h-full max-w-full object-contain"
                initial={{ filter: "grayscale(100%)" }}
                whileHover={{ 
                  filter: "grayscale(0%)",
                  transition: { duration: 0.3 }
                }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
